import { growthBookInstance } from 'hooks/useGrowthBookInitialization'

export const getActiveGbSegmentNames = (
  experimentsMap: Record<string, Record<string, string>> | null,
): string[] => {
  if (!experimentsMap) return []

  return [...growthBookInstance.getAllResults().values()]
    .filter(({ result }) => result.hashUsed)
    .map(
      ({ experiment, result }) =>
        experimentsMap[experiment.key]?.[String(result.variationId)],
    )
    .filter(Boolean) as string[]
}
